export const PROFILE_MANAGER_ROLES = ['manager', 'supervisor'];
export const isProfileManagerType = (userRole) => {
    return PROFILE_MANAGER_ROLES.includes(userRole || '');
};
export const userManagesStudentProfile = (userRole, profileRole) => {
    return isProfileManagerType(userRole) && profileRole === 'student';
};
export const PROFILE_PHOTO_OWNER_ROLES = [...PROFILE_MANAGER_ROLES, 'student'];
export const userCanUploadProfilePhoto = (userRole, profileRole, userCheckingOwnProfile) => {
    const ownerCanUpload = Boolean(userCheckingOwnProfile) && PROFILE_PHOTO_OWNER_ROLES.includes(userRole || '');
    return ownerCanUpload || userManagesStudentProfile(userRole, profileRole);
};
export const PROFILE_LOGS_VIEWER_ROLES = [...PROFILE_MANAGER_ROLES, 'teacher', 'tutor'];
export const userCanViewStudentLogs = (userRole, profileRole) => {
    return PROFILE_LOGS_VIEWER_ROLES.includes(userRole || '') && profileRole === 'student';
};
export const STUDENT_RESTRICTED_PROFILE_CARDS = ['Desempenho', 'Matrículas'];
export const shouldHideRestrictedProfileCards = (userRole, userCheckingOwnProfile) => {
    return userRole === 'student' && !userCheckingOwnProfile;
};
export const ACADEMIC_PERFORMANCE_NO_DATA_LABEL = 'Sem dados';
export const ACADEMIC_PERFORMANCE_LEVELS = [
    { min: 81, label: 'Excelente' },
    { min: 70, label: 'Bom' },
    { min: 50, label: 'Regular' },
    { min: 0, label: 'Ruim' }
];
export const getAcademicPerformanceLabel = (percentage) => {
    if (percentage === null || percentage === undefined || percentage === '')
        return ACADEMIC_PERFORMANCE_NO_DATA_LABEL;
    const percentageValue = Number(percentage);
    if (isNaN(percentageValue))
        return ACADEMIC_PERFORMANCE_NO_DATA_LABEL;
    const level = ACADEMIC_PERFORMANCE_LEVELS.find((performanceLevel) => percentageValue >= performanceLevel.min);
    return level?.label || ACADEMIC_PERFORMANCE_NO_DATA_LABEL;
};
